export const UPDATE_CHANGE_ADDRESS = 'UPDATE_CHANGE_ADDRESS';

export const updateIsAddressChange = data => ({
  type: UPDATE_CHANGE_ADDRESS,
  payload: data
});
